import { Component, OnDestroy, AfterViewInit, HostListener, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Portal } from '@angular/cdk/portal';
import { ActionBarService } from './action-bar.service';
import { takeUntil, delay } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { State, getDirection, getMobile } from '@cemex/cmx-client-layout';

@Component({
  selector: 'app-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss'],
})
export class ActionBarComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroyed$ = new Subject();

  direction = 'ltr';
  mobile = false;

  hideBarOnMobile = false;
  allowFab = false;
  fabOpen = false;

  portal: Portal<any>;
  buttonsPortal: Portal<any>;

  constructor(
    private service: ActionBarService,
    private store: Store<State>,
  ) {}

  ngOnInit() {
    this.store.pipe(select(getDirection), takeUntil(this.destroyed$)).subscribe((direction) => {
      this.direction = direction;
    });

    this.store.pipe(select(getMobile), takeUntil(this.destroyed$)).subscribe((value) => {
      this.mobile = value;
    });
  }

  ngAfterViewInit() {
    this.service.portal$.pipe(delay(0), takeUntil(this.destroyed$)).subscribe((portal) => {
      this.portal = portal;
    });
    this.service.buttonsPortal$.pipe(delay(0), takeUntil(this.destroyed$)).subscribe((portal) => {
      this.buttonsPortal = portal;
    });
    this.service.allowFloatingButton$.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
      this.allowFab = value;
    });
    this.service.hideActionBarOnMobile$.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
      this.hideBarOnMobile = value;
    });
  }

  @HostListener('document:click', ['$event'])
  clickOutside() {
    if (this.fabOpen) {
      this.fabOpen = false;
    }
  }

  @HostListener('document:mouseup', ['$event'])
  touchOutside() {
    if (this.fabOpen) {
      this.fabOpen = false;
    }
  }

  onBackdropClicked(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  fabButtonOnClick(event) {
    this.fabOpen = !this.fabOpen;
    // stop the event, so it won't be caught again in clickOutside listener, where any
    // change on fabOpen would be negated
    event.stopPropagation();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
